import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'
import React from 'react'
import { compose } from 'recompose'
import withSort from '../../../../elements/HOC/withSort'
import CurrencySelect from '../../../../elements/Select/Currency'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import {defaultFormItemLayout, rules, threeFormItemLayout} from '../../../../modules/FormItems'
import { dateVal } from '../../../../modules/Utils'

function KeyTerms(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { contract } = props

  const [count, setCount] = React.useState(get(contract, 'interest', []).length || 1)
  const [currencyCount, setCurrencyCount] = React.useState(get(contract, 'currency', []).length || 1)
  //if (type === 'view') columns = this.columns.filter(c => c.dataIndex !== 'operation')

  const isShow = ['card', 'deposit', 'loan', undefined].includes(contract.type)
  const isDeposit = ['deposit'].includes(contract.type)
  const isBank = ['bank', undefined].includes(contract.type)
  const isCC = ['card'].includes(contract.type)
  const isLoan = ['loan'].includes(contract.type)

  const isLimit = getFieldValue('isOverdraft') === true || isCC || isLoan

  const isMultiCurrency = getFieldValue('isMultiCurrency') === true

  const ordinalNumeral = [
    'Primary',
    'Secondary',
    'Tertiary',
    'Quaternary',
    'Quinary',
    'Senary',
    'Septenary',
    'Octonary',
    'Nonary',
    'Decenary',
    'Undenary',
    'Duodenary',
  ]

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <Form.Item label="Start Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.start', {
              initialValue: dateVal(contract, 'date.start'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} placeholder="Start Date" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...isLoan ? ({label:'Date of Maturity'}) : ({label:'End Date'})} {...defaultFormItemLayout}>
            {getFieldDecorator('date.expiry', {
              initialValue: dateVal(contract, 'date.expiry'),
            })(<DatePicker style={{ width: '100%' }} placeholder="Date of Maturity" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...isLoan ? ({label:'Drawdown Date'}) : ({label:'Effective Date'})} {...defaultFormItemLayout}>
            {getFieldDecorator('date.effective', {
              initialValue: dateVal(contract, 'date.effective'),
              //rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} placeholder="Drawdown Date" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Statement Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.statement', {
              initialValue: dateVal(contract, 'date.statement'),
            })(<DatePicker style={{ width: '100%' }} placeholder="Statement  Date" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {isLimit && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} {...isLoan ? ({label:'Max Loan Amount'}) : isCC ? ({label:'Credit Card Limit'}) : ({label:'Overdraft Limit'})}>
            {getFieldDecorator('limit', {
              initialValue: get(contract, 'limit'),
            })(<InputNumber style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} {...isLimit ? ({label:'Currency'}) : ({label:`${ordinalNumeral[0]} Currency`})}>
            {getFieldDecorator('currency[0]', {
              initialValue: get(contract, 'currency[0]'),
              rules: rules.select,
            })(<CurrencySelect placeholder={'Currency'} />)}
          </Form.Item>
        </Col>
      </Row>
      {isBank && (
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Is MultiCurrency'}>
            {getFieldDecorator('isMultiCurrency', {
              initialValue: get(contract, 'isMultiCurrency'),
              valuePropName: 'checked',
            })(<Checkbox />)}

            {isMultiCurrency && (
              <>
                <Icon
                  style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                  type="plus-circle"
                  theme="filled"
                  onClick={() => setCurrencyCount((prvG) => prvG + 1)}
                />
                {currencyCount > 1 && (
                  <Icon
                    style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                    type="minus-circle"
                    theme="filled"
                    onClick={() => setCurrencyCount((prvG) => prvG - 1)}
                  />
                )}
              </>
            )}
          </Form.Item>
        </Col>
        {isMultiCurrency &&
        [...Array(currencyCount).keys()].map((i) => (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={`${ordinalNumeral[i + 1]} Currencies`}>
              {getFieldDecorator(`currency[${i + 1}]`, {
                initialValue: get(contract, `currency[${i + 1}]`),
                rules: rules.select,
              })(<CurrencySelect placeholder={`Multi Currencies`} />)}
            </Form.Item>
          </Col>
        ))}
      </Row>
      )}
      {isLoan && (
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Repayment Type">
                {getFieldDecorator('repaymentType', {
                  initialValue: get(contract, 'repaymentType'),
                })(<RepaymentTypeSelect />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Repayment Period">
                {getFieldDecorator('repaymentPeriod', {
                  initialValue: get(contract, 'repaymentPeriod'),
                })(<RepaymentPeriodSelect />)}
              </Form.Item>
            </Col>
          </Row>
      )}

          {/*<Row>
            <Form.Item {...defaultFormItemLayout} label={'Has Penalty'}>
              {getFieldDecorator('hasPenalty', {
                initialValue: get(contract, 'hasPenalty'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>

            {getFieldValue('hasPenalty') === true && (
              <>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Penalty Interest">
                    {getFieldDecorator('penaltyInterest', {
                      initialValue: get(contract, 'penaltyInterest'),
                    })(<InputNumber style={{ width: '100%' }} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label="Penalty Interest Period">
                        {getFieldDecorator('penaltyInterestPeriod', {
                          initialValue: get(contract, 'penaltyInterestPeriod'),
                          //rules: rules.select,
                        })(<InterestPeriodSelect />)}
                      </Form.Item>
                    </Col>
              </>
            )}
          </Row>*/}

          <Row>
            <h3>
              INTEREST
              <Icon
                style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                type="plus-circle"
                theme="filled"
                onClick={() => setCount((prvG) => prvG + 1)}
              />
              {count > 1 && (
                <Icon
                  style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                  type="minus-circle"
                  theme="filled"
                  onClick={() => setCount((prvG) => prvG - 1)}
                />
              )}
            </h3>
            {[...Array(count).keys()].map((i) => (
              <InterestForm {...{ index: i, contract, key: i + 'Interest', getFieldDecorator }} />
            ))}
          </Row>
    </Form>
  )
}

function InterestForm({ index, contract, getFieldDecorator }) {
  return (
    <Row>
      <Col span={8}>
        <Form.Item {...threeFormItemLayout} label="Name">
          {getFieldDecorator(`interest[${index}].name`, {
            initialValue: get(contract, `interest[${index}].name`),
            //rules: rules.select,
          })(<Input style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...threeFormItemLayout} label="Rate">
          {getFieldDecorator(`interest[${index}].rate`, {
            initialValue: get(contract, `interest[${index}].rate`),
            //rules: rules.input,
          })(<Input style={{ width: '100%' }} type={'number'} precision={2} suffix="%" />)}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...threeFormItemLayout} label="Accural">
          {getFieldDecorator(`interest[${index}].period`, {
            initialValue: get(contract, `interest[${index}].period`),
            //rules: rules.select,
          })(<InterestPeriodSelect />)}
        </Form.Item>
      </Col>
      {/*<Col span={6}>
        <Form.Item {...defaultFormItemLayout} label="Type">
          {getFieldDecorator(`interest[${index}].type`, {
            initialValue: get(contract, `interest[${index}].type`),
            //rules: rules.select,
          })(<InterestTypeSelect />)}
        </Form.Item>
      </Col>*/}
    </Row>
  )
}

const InterestRateSelect = compose(
  withData({
    data: [
      { value: '0%', key: 0 },
      { value: '10%', key: 10 },
      { value: '20%', key: 20 },
      { value: '30%', key: 30 },
      { value: '40%', key: 40 },
      { value: '50%', key: 50 },
      { value: '60%', key: 60 },
      { value: '70%', key: 70 },
      { value: '80%', key: 80 },
      { value: '90%', key: 90 },
      { value: '100%', key: 100 },
    ],
  })
)(CustomSelect)

const InterestPeriodSelect = compose(
  withData({
    data: [
      {
        value: 'Annually',
        key: 'annual',
      },
      {
        value: 'Daily',
        key: 'daily',
      },
      {
        value: 'Weekly',
        key: 'weekly',
      },
      {
        value: 'Monthly',
        key: 'monthly',
      },
      {
        value: 'Fixed for Term',
        key: 'term',
      },
    ],
  }),
  withSort
)(CustomSelect)

const RepaymentTypeSelect = compose(
  withData({
    data: [
      { value: 'Principal & Interest', key: 'principal&interest' },
      { value: 'Interest Only', key: 'interestOnly' },
    ],
  }),
  withSort
)(CustomSelect)

const RepaymentPeriodSelect = compose(
  withData({
    data: [
      { value: 'Annually', key: 'annual' },
      { value: 'Monthly', key: 'monthly' },
      { value: 'Weekly', key: 'weekly' },
      { value: 'End of Term', key: 'term' },
    ],
  }),
  withSort
)(CustomSelect)

const InterestTypeSelect = compose(
  withData({
    data: [
      { value: 'Fixed Dates', key: 'fixedDates' },
      { value: 'Monthly', key: 'monthly' },
      { value: 'Quarterly', key: 'quarterly' },
      { value: 'End of Term', key: 'endOfTerm' },
    ],
  }),
  withSort
)(CustomSelect)

export default Form.create()(KeyTerms)
